// Support component names relative to this directory:
import ReactOnRails from 'react-on-rails';

import IssueTracking from 'public/IssueTracking';
import OptInWidget from 'public/components/OptInWidget';
import OptInResult from 'public/pages/OptIn/Result';

import './widget_styles.scss';

ReactOnRails.register({
  IssueTracking,
  OptInWidget,
  'OptIn::Result': OptInResult,
});
